module.exports = __webpack_public_path__ + "static/media/COnnessione REVCON_Stampa1.8b6549ea.png";